"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prism_1 = require("./prism");

require("prismjs/plugins/autoloader/prism-autoloader");

var languages_1 = __importDefault(require("./available/languages"));

var themes_1 = __importDefault(require("./available/themes"));

var currentAutoload = null;
exports.HTTP_AUTOLOAD_PATH = process.env.PRISM_HTTP_AUTOLOAD_PATH || './prismjs/';
exports.CDN_AUTOLOAD_PATH = process.env.PRISM_CDN_AUTOLOAD_PATH || 'https://cdnjs.cloudflare.com/ajax/libs/prism/1.19.0/';
/**
 * @return the currently set autoloader path, if set
 */

exports.getAutoload = function () {
  return currentAutoload;
};
/**
 * Enables or disables loading of languages via prismjs [autoloader](https://prismjs.com/plugins/autoloader/)
 * Set to null to disable automatic loading.
 *
 * @param url URL or path to the prismjs location (should contain /components and /themes folders)
 */


exports.setAutoload = function (url) {
  currentAutoload = url;

  if (prism_1.Prism.plugins.autoloader) {
    prism_1.Prism.plugins.autoloader.languages_path = url && url + "components/";
  }
};

exports.createHttpLanguageProvider = function (prismPath) {
  var result = {};

  var loader = function loader() {
    return exports.setAutoload(prismPath);
  };

  return languages_1.default.reduce(function (result, language) {
    var _a;

    return Object.assign(result, (_a = {}, _a[language] = loader, _a));
  }, result);
};

exports.createHttpThemeProvider = function (prismPath, loader) {
  var result = {};
  return themes_1.default.reduce(function (result, theme) {
    var _a;

    return Object.assign(result, (_a = {}, _a[theme] = function () {
      return loader(theme, prismPath);
    }, _a));
  }, result);
};